<template>
  <div class="organizer-tab">
    <ChatThread
      :messages="organizerMessages"
      :current-user-id="currentUserId"
      :role-map="roleMap"
    />
    <div class="organizer-tab__input-row">
      <v-text-field
        v-model="newMessage"
        placeholder="Message organizers..."
        outlined
        dense
        hide-details
        :disabled="sending"
        class="organizer-tab__input"
        @keydown.enter.prevent="submitMessage"
      />
      <v-btn
        icon
        color="primary"
        small
        class="organizer-tab__send-btn"
        :disabled="!newMessage.trim() || sending"
        :loading="sending"
        @click="submitMessage"
      >
        <v-icon
          small
          color="white"
        >
          mdi-send
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ChatThread from './ChatThread.vue';

export default {
  name: 'OrganizerChatTab',

  components: { ChatThread },

  props: {
    currentUserId: {
      type: Number,
      default: null,
    },
    roleMap: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      newMessage: '',
      sending: false,
    };
  },

  computed: {
    ...mapGetters('webinarChat', ['organizerMessages']),
  },

  methods: {
    ...mapActions('webinarChat', ['sendOrganizerMessage']),

    async submitMessage() {
      if (!this.newMessage.trim() || this.sending) return;
      this.sending = true;
      try {
        await this.sendOrganizerMessage(this.newMessage.trim());
        this.newMessage = '';
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.organizer-tab {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__input-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    background: #fafafa;
    flex-shrink: 0;
  }

  &__input {
    ::v-deep .v-input__slot {
      border-radius: 20px !important;
      min-height: 36px !important;
      padding: 0 14px !important;
      background: #fff !important;
      border: 1.5px solid rgba(0, 0, 0, 0.12) !important;
      transition: border-color 0.2s ease;

      &:hover {
        border-color: rgba(244, 119, 33, 0.4) !important;
      }
    }

    ::v-deep .v-input__slot fieldset {
      display: none;
    }

    ::v-deep .v-text-field__slot input {
      font-size: 13px;
      padding: 6px 0;
    }

    ::v-deep .v-input--is-focused .v-input__slot {
      border-color: #f47721 !important;
      box-shadow: 0 0 0 1px rgba(244, 119, 33, 0.15);
    }
  }

  &__send-btn {
    background: #f47721 !important;
    color: #fff !important;
    width: 34px;
    height: 34px;

    &.v-btn--disabled {
      background: #e0e0e0 !important;
      color: rgba(0, 0, 0, 0.26) !important;
    }
  }
}
</style>
